import { Link, useNavigate } from "react-router-dom";
import methodModel from "../methods";
import { useEffect, useState } from "react";
import ApiClient from "../api/apiClient";
import loader from "../loader";
import { toast } from "react-toastify";

export default function Forgot() {
  const token =localStorage.getItem("token");
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const inValidEmail = methodModel.emailvalidation(email);
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    if (token) {
      navigate("/profile");
    }
  }, []);

  const hendleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    if (!inValidEmail) return;
    loader(true);
    ApiClient.post("user/forgot/password", { email }).then((res) => {
      if (res.success) {
        setSubmitted(false);
        toast.success(res.message);
        navigate("/login");
      }
      loader(false);
    });
  };
  return (
    <>
      <div
        className="h-screen overflow-auto flex !bg-bottom !bg-cover !bg-no-repeat p-5"
        style={{ background: "url('assets/img/auth-bg.webp')" }}
      >
        <div className="w-full m-auto">
          <div className="auth-page grid grid-cols-12 gap-3 max-w-[500px] md:max-w-[900px] w-full rounded-[20px] bg-white sm:px-10 p-5 py-10 mx-auto relative">
            <div className="col-span-5 max-md:hidden">
              <div className="flex flex-col gap-y-[6rem] justify-between h-full">
                <Link to="/">
                  <img
                    src="/assets/img/logo.png"
                    class="w-[120px] md:w-[120px] object-contain cursor-pointer mx-auto"
                  />
                </Link>
                <div className="relative top-[10px]">
                  <img
                    src="/assets/img/auth-left-img.png"
                    className="w-full h-full object-contain scale-[1.6]"
                  />
                </div>
              </div>
            </div>
            <div className="col-span-12 md:col-span-7 flex h-full items-center md:ml-[4rem] z-10">
              <form onSubmit={(e) => hendleSubmit(e)} className="w-full">
                <div className="space-y-3">
                  <img
                    src="/assets/img/circle-2.png"
                    className="w-125px h-[125px] object-contain absolute right-5 top-0"
                  />
                  <img
                    src="/assets/img/logo.png"
                    class="w-[120px] md:w-[120px] object-contain cursor-pointer mx-auto md:hidden"
                  />
                  <div className="space-y-1">
                    <h3 className="text-2xl text-[#414141] text-center font-semibold">
                      Forgot Password
                    </h3>
                  </div>
                  <p className="text-sm text-center text-[#737373]">
                    No worries! Just enter your email and we’ll send you a reset
                    password link.
                  </p>
                </div>
                <div className="space-y-4 mt-7">
                  <div className="w-full space-y-1">
                    <label className="text-sm font-[400] text-[#737373]">
                      Email Address
                    </label>
                    <div className="relative">
                      <input
                        type="email"
                        value={email}
                        placeholder="Enter your email"
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        className="border !outline-none h-11 rounded-[12px] w-full text-[12px] pl-4"
                      />
                      {email && !inValidEmail && submitted && (
                        <span role="alert" className="text-[#c53030] text-xs mt-1 mb-4 block">
                          Please enter valid email
                        </span>
                      )}
                    </div>
                  </div>
                </div>

                <div className="mt-8">
                  <button
                    type="submit"
                    className="bg-[linear-gradient(45deg,#115B9D,#062037)] w-full text-sm font-[600] text-white h-11 flex items-center justify-center gap-2 rounded-[12px] shadow-btn hover:opacity-80 transition-all focus:ring-2 ring-[#EDEBFC] disabled:bg-[#D0CAF6] disabled:cursor-not-allowed !px-4"
                  >
                    Submit
                  </button>
                </div>

                <div className="flex gap-1 justify-center mt-5">
                  <p className="text-sm text-[#737373]">Just Remember?</p>
                  <Link
                    to="/login"
                    className="text-sm font-semibold text-[#115B9D] cursor-pointer hover:opacity-80"
                  >
                    Login
                  </Link>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
